import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["additionalSoftwareIsUsed", "specifySoftware"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { SelectMenu, toast, Icon, BackdropLoader } from '@livable/saas-react-components';
import { Typography, TextField, Button, Grid, ToggleButtonGroup, ToggleButton, MenuItem } from '@mui/material';
import { useFormik } from 'formik';
import { track, events } from 'src/configs/amplitude';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import { companyDetailsSchema } from 'src/utils/formValidation/Company';
import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
import SplitPageContainer from 'src/components/shared/SplitPageContainer';
import { generateAddressString } from 'src/utils/address';
import inviteSvg from 'src/img/invite.svg';
import { softwareList } from 'src/utils/company';
import useStyles from './styles';
export const CompanyDetailsPage = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Company Details';
  const userPhoneConfirmed = JSON.parse(localStorage.getItem(USER_SETTINGS_KEYS.phoneConfirmed));
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    handleStartValidate = _useState2[0],
    setHandleStartValidate = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    defaultPropertyAddress = _useState4[0],
    setDefaultPropertyAddress = _useState4[1];
  const _useState5 = useState('no'),
    _useState6 = _slicedToArray(_useState5, 2),
    loadedUsingSoftware = _useState6[0],
    setLoadedUsingSoftware = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    loadedSoftware = _useState8[0],
    setLoadedSoftware = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isAwaitProcess = _useState0[0],
    setIsAwaitProcess = _useState0[1];
  const _useState1 = useState({
      id: null,
      name: null,
      postalAddress: null,
      propertyManagementSoftware: null,
      unitsProjected: null
    }),
    _useState10 = _slicedToArray(_useState1, 2),
    currentCompanyData = _useState10[0],
    setCurrentCompanyData = _useState10[1];
  const handleAdditionalSoftwareIsUsedChange = event => {
    if (event.target.value) {
      track(events.toggled('Software'), {
        page
      });
      store.company.setRegisterNewCompanyField('additionalSoftwareIsUsed', event.target.value);
    }
  };
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  const formik = useFormik({
    initialValues: store.company.registerNewCompany,
    validationSchema: companyDetailsSchema,
    enableReinitialize: true,
    onSubmit: async () => {
      setHandleStartValidate(true);
      store.account.setIsSavingCompany(true);
    }
  });
  const handleEndSubmitting = async () => {
    store.account.setIsSavingCompany(false);
  };
  const handleStartSubmitting = async resultId => {
    store.account.setIsSavingCompany(true);
    const _formik$values = formik.values,
      additionalSoftwareIsUsed = _formik$values.additionalSoftwareIsUsed,
      specifySoftware = _formik$values.specifySoftware,
      otherValues = _objectWithoutProperties(_formik$values, _excluded);
    const data = _objectSpread({
      companyType: 'IndependentRentalOwner',
      website: '',
      addressId: resultId
    }, otherValues);
    if (store.company.registerNewCompany.additionalSoftwareIsUsed === 'yes' && data.propertyManagementSoftware === 'other') data.propertyManagementSoftware = specifySoftware;
    if (store.company.registerNewCompany.additionalSoftwareIsUsed === 'no') data.propertyManagementSoftware = '';
    if (!!currentCompanyData.id) {
      const updateCompanyResp = await store.company.updateCompanyAsync.run(data);
      if (updateCompanyResp && updateCompanyResp.isSuccessful) navigate('/paygate');
    } else {
      const resp = await store.company.createNewCompanyAsync.run(data);
      if (resp && resp.isSuccessful) {
        setIsAwaitProcess(true);
        for (let count = 0; count < 5; count++) {
          await store.account.refreshAccessTokenAsync.run();
          const accessTokenAsync = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
          if (accessTokenAsync['custom:companyid']) {
            store.company.resetRegisterNewCompany();
            // Give backend time to propagate (e.g. Stripe customer) before paygate payment calls
            await sleep(3000);
            setIsAwaitProcess(false);
            navigate('/paygate');
            break;
          } else {
            if (count === 4) {
              store.account.setIsSavingCompany(false);
              toast('error', {
                body: ['Something went wrong']
              });
            }
          }
          await sleep(3000);
        }
        setIsAwaitProcess(false);
      } else {
        store.account.setIsSavingCompany(false);
      }
    }
  };
  const leftBlockContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    color: "white"
  }, t('sign_up_flow.tell_about_business'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, t('sign_up_flow.our_ratio_utility_billing'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, t('sign_up_flow.testimonials'))), /*#__PURE__*/React.createElement("div", {
    className: classes.quote
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, t('sign_up_flow.house_provider_testimonial'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, "Jason Gamble, Housing Provider")), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "white"
  }, t('sign_up_flow.good_for_wallet'))));
  const breadcrumbs = [{
    title: t('sign_up_flow.mfa'),
    link: !!currentCompanyData.id ? false : '/mfa',
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success",
      fontSize: "small",
      state: "primary"
    })
  }, {
    title: t('sign_up_flow.business_information'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "edit",
      fontSize: "small"
    })
  }, {
    title: t('sign_up_flow.payment_information'),
    isDisabled: true
  }];
  const getCurrentUserCompanyFromToken = async () => {
    const resp = await store.company.getCurrentUserCompanyFromTokenAsync.run();
    return resp;
  };
  useEffect(() => {
    getCurrentUserCompanyFromToken().then(async resp => {
      if (resp && resp.isSuccessful) {
        const _resp$response = resp.response,
          id = _resp$response.id,
          name = _resp$response.name,
          address = _resp$response.address,
          propertyManagementSoftware = _resp$response.propertyManagementSoftware,
          unitsProjected = _resp$response.unitsProjected,
          addressId = _resp$response.addressId;
        store.company.resetRegisterNewCompany();
        setCurrentCompanyData({
          id: id,
          name: name,
          postalAddress: generateAddressString(address),
          propertyManagementSoftware: propertyManagementSoftware,
          unitsProjected: "".concat(unitsProjected)
        });
        if (addressId) {
          const addressResp = await store.address.batchGetAddressesAsync.run({
            addressIds: [addressId]
          });
          if (addressResp && addressResp.isSuccessful) {
            setDefaultPropertyAddress(addressResp.response[0]);
          }
        }
        store.company.setRegisterNewCompanyField('name', name);
        store.company.setRegisterNewCompanyField('postalAddress', generateAddressString(address));
        store.company.setRegisterNewCompanyField('unitsProjected', unitsProjected ? "".concat(unitsProjected) : '');
        if (propertyManagementSoftware) {
          store.company.setRegisterNewCompanyField('additionalSoftwareIsUsed', 'yes');
          setLoadedUsingSoftware('yes');
          setLoadedSoftware(propertyManagementSoftware);
          if (!softwareList.includes(propertyManagementSoftware)) {
            store.company.setRegisterNewCompanyField('propertyManagementSoftware', 'other');
            store.company.setRegisterNewCompanyField('specifySoftware', propertyManagementSoftware);
          } else {
            store.company.setRegisterNewCompanyField('propertyManagementSoftware', propertyManagementSoftware);
          }
        }
        store.account.setIsSavingPaygate(false);
        setTimeout(() => {
          formik.setFieldTouched('name', true);
          formik.setFieldTouched('postalAddress', true);
          if (unitsProjected && unitsProjected.length) formik.setFieldTouched('unitsProjected', true);
        }, 0);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(SplitPageContainer, {
    imageScr: inviteSvg,
    leftBlock: leftBlockContent,
    breadcrumbs: breadcrumbs,
    showLogOutButton: true
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit,
    className: classes.relativeForm
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    marginBottom: "32px"
  }, t('company_details.get_to_know')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.enter_business_name'),
    variant: "outlined",
    fullWidth: true,
    id: "name",
    name: "name",
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress,
    value: formik.values.name,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Business Name'), {
          page
        });
      }
    },
    onChange: e => {
      store.company.setRegisterNewCompanyField('name', e.target.value);
      formik.handleChange(e);
    },
    error: formik.touched.name && Boolean(formik.errors.name),
    helperText: formik.touched.name && t(formik.errors.name, {
      field: t('general.business_name')
    })
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    _serviceEndSubmitting: handleEndSubmitting,
    defaultPropertyAddress: defaultPropertyAddress,
    error: formik.touched.postalAddress && Boolean(formik.errors.postalAddress),
    helperText: formik.touched.postalAddress && t(formik.errors.postalAddress, {
      field: t('company_details.corporate_postal_mailing_address')
    }),
    name: "postalAddress",
    validator: formik
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    type: "number",
    variant: "h4"
  }, t('company_details.how_many_units'))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.number_of_units_optional'),
    variant: "outlined",
    type: "string",
    fullWidth: true,
    id: "unitsProjected",
    name: "unitsProjected",
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress,
    value: formik.values.unitsProjected,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Units'), {
          page
        });
      }
    },
    onChange: e => {
      if (!/^[1-9][0-9]*$|^$/.test(e.target.value)) return;
      store.company.setRegisterNewCompanyField('unitsProjected', e.target.value);
      formik.handleChange(e);
    },
    error: formik.touched.unitsProjected && Boolean(formik.errors.unitsProjected),
    helperText: formik.touched.unitsProjected && t(formik.errors.unitsProjected)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('company_details.using_pm_software'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.flexContainer, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: store.company.registerNewCompany.additionalSoftwareIsUsed,
    onChange: handleAdditionalSoftwareIsUsedChange,
    exclusive: true,
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "no"
  }, t('general.no')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "yes"
  }, t('general.yes'))), store.company.registerNewCompany.additionalSoftwareIsUsed === 'yes' && /*#__PURE__*/React.createElement("div", {
    className: classes.inlineSelect
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "propertyManagementSoftware",
    name: "propertyManagementSoftware",
    value: formik.values.propertyManagementSoftware,
    label: t('general.please_select'),
    labelId: "software-selector-label",
    onChange: e => {
      store.company.setRegisterNewCompanyField('propertyManagementSoftware', e.target.value);
      formik.handleChange(e);
      track(events.selected('Software'), {
        page
      });
    },
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress,
    error: formik.touched.propertyManagementSoftware && Boolean(formik.errors.propertyManagementSoftware),
    helperText: formik.touched.propertyManagementSoftware && t(formik.errors.propertyManagementSoftware, {
      field: t('company_details.property_management_software')
    })
  }, softwareList.map(software => /*#__PURE__*/React.createElement(MenuItem, {
    value: software,
    key: software
  }, software)), /*#__PURE__*/React.createElement(MenuItem, {
    value: "other"
  }, t('general.other')))), store.company.registerNewCompany.additionalSoftwareIsUsed === 'yes' && formik.values.propertyManagementSoftware === 'other' && /*#__PURE__*/React.createElement(TextField, {
    label: t('general.specify_optional'),
    variant: "outlined",
    fullWidth: true,
    id: "specifySoftware",
    name: "specifySoftware",
    value: formik.values.specifySoftware,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Software'), {
          page
        });
      }
    },
    onChange: e => {
      store.company.setRegisterNewCompanyField('specifySoftware', e.target.value);
      formik.handleChange(e);
    },
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress,
    error: formik.touched.specifySoftware && Boolean(formik.errors.specifySoftware),
    helperText: formik.touched.specifySoftware && t(formik.errors.specifySoftware)
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.buttonsWrapper, " ").concat(classes.xxlSection)
  }, /*#__PURE__*/React.createElement(Button, {
    id: "createAccount",
    variant: "priority",
    fullWidth: true,
    type: "submit",
    disabled: isAwaitProcess || !formik.isValid || !Object.keys(formik.touched).length || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress || currentCompanyData.name === formik.values.name && currentCompanyData.postalAddress === formik.values.postalAddress && currentCompanyData.unitsProjected === "".concat(formik.values.unitsProjected) && loadedUsingSoftware === store.company.registerNewCompany.additionalSoftwareIsUsed && (!!store.company.registerNewCompany.specifySoftware && store.company.registerNewCompany.propertyManagementSoftware === 'other' && store.company.registerNewCompany.specifySoftware === loadedSoftware || !store.company.registerNewCompany.specifySoftware && store.company.registerNewCompany.propertyManagementSoftware !== 'other' && store.company.registerNewCompany.propertyManagementSoftware === loadedSoftware) || store.company.registerNewCompany.additionalSoftwareIsUsed === 'yes' && !store.company.registerNewCompany.propertyManagementSoftware.length || store.company.registerNewCompany.additionalSoftwareIsUsed === 'yes' && store.company.registerNewCompany.propertyManagementSoftware === 'other' && !store.company.registerNewCompany.specifySoftware,
    onClick: () => {
      if (!!currentCompanyData.id) {
        track(events.clicked('Save Changes'), {
          page
        });
      } else {
        track(events.clicked('Create Company'), {
          page
        });
      }
    },
    'custom-attribute': '523-company-details-page'
  }, !!currentCompanyData.id ? t('buttons.save_changes') : t('buttons.confirm_and_create')), !userPhoneConfirmed && !currentCompanyData.id && /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    onClick: () => track(events.clicked('Back To MFA'), {
      page
    }),
    variant: "text",
    to: "/mfa",
    fullWidth: true,
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress,
    'custom-attribute': '524-company-details-page'
  }, t('buttons.back')), !!currentCompanyData.id && /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    onClick: () => track(events.clicked('Go To Paygate'), {
      page
    }),
    variant: "text",
    to: "/paygate",
    fullWidth: true,
    disabled: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress,
    'custom-attribute': '525-company-details-page'
  }, t('sign_up_flow.go_to_paygate'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isAwaitProcess || store.company.updateCompanyAsync.inProgress || store.company.createNewCompanyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress || store.address.batchGetAddressesAsync.inProgress
  })));
});